export default __webpack_public_path__ + "static/media/Logo1.dc6066ed.png";